import { render, staticRenderFns } from "./ChooseImage.vue?vue&type=template&id=21a85f90&scoped=true&"
import script from "./ChooseImage.vue?vue&type=script&lang=js&"
export * from "./ChooseImage.vue?vue&type=script&lang=js&"
import style0 from "./ChooseImage.vue?vue&type=style&index=0&id=21a85f90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a85f90",
  null
  
)

export default component.exports